<template>
  <div class="DataDownload">
    <div class="DataDownload_content flex_col">
      <el-table
        :data="dowloadList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :show-header="false"
      >
        <el-table-column prop="title" width="680" class="tab1">
        </el-table-column>
        <el-table-column prop="updateTime" width="200">
          <template slot-scope="scope"
            >更新日期：{{
              scope.row.updateTime ? scope.row.updateTime : "暂无时间"
            }}</template
          >
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="downLoad(scope.$index, scope.row)"
              >点击下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getFileDowloadApi } from "@/api/index";

export default {
  components: {
    // Paging
  },
  data() {
    return {
      dowloadList: [],
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      updateTime: "",
    };
  },
  mounted() {
    this.getFileDowload();
  },
  methods: {
    //下载
    downLoad(index, row) {
      location.href = row.url;
    },
    //列表样式
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //获取下载列表
    getFileDowload() {
      var data = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: 1,
      };
      getFileDowloadApi(data).then((res) => {
        // console.log("datadown",res)
        this.dowloadList = res.data.list;
        this.total = res.data.totalCount;
        this.updateTime = res.data.list.forEach((item) => {
          // console.log("***********",item.updateTime)
          return item.updateTime;
        });
      });
    },
  },
};
</script>
<style scoped>
.DataDownload {
  width: 1200px;
  margin: 0 auto;
}
.DataDownload_content {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 100px;
}

.el-table {
  border: 1px solid #e5e5e5;
}

div /deep/ .el-table .warning-row {
  background: #f2f5fa;
}

div /deep/ .el-table .success-row {
  background: #f2f5fa;
}
div /deep/ .el-table_1_column_2 {
  color: #999999;
}
.el-button--primary {
  background-color: #2968bd;
}

/* .DataDownload_content_file {
} */
</style>



// WEBPACK FOOTER //
// src/views/DataDownload.vue